export enum FillTimeLineItemTypeEnum {
  ALL = "ALL",
  SPRINT = "SPRINT",
}
